export default {"src":"/_next/static/media/lock_64.1933572a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};